// User-facing display labels (presentation only). Internal identifiers,
// routes, schema keys and storage keys (e.g. "opstate", rsc.engSession.v1)
// are unchanged — do not use these strings as keys.
export const LABELS = {
  opstate: "Rig Operations",
  engSession: "Rig Engineering",
};

export const SETUP_STATUS = {
  not_started: { label: "NOT STARTED", color: "rgba(148,163,184,0.9)", bg: "rgba(148,163,184,0.12)", border: "rgba(148,163,184,0.35)" },
  in_progress: { label: "IN PROGRESS", color: "var(--rs-amber)", bg: "rgba(255,179,0,0.12)", border: "rgba(255,179,0,0.4)" },
  ready:       { label: "COMPLETE", color: "#4ADE80", bg: "rgba(74,222,128,0.1)", border: "rgba(74,222,128,0.35)" },
  attention:   { label: "NEEDS ATTENTION", color: "#FCA5A5", bg: "rgba(239,68,68,0.1)", border: "rgba(239,68,68,0.4)" },
  optional:    { label: "OPTIONAL", color: "rgba(148,163,184,0.9)", bg: "rgba(148,163,184,0.08)", border: "rgba(148,163,184,0.28)" },
  connected:   { label: "CONNECTED", color: "#4ADE80", bg: "rgba(74,222,128,0.1)", border: "rgba(74,222,128,0.35)" },
};
